import React from 'react';
import './AboutUs.css';

function AboutUs() {
  return (
    <div className="about-page">
      <div className="about-container">
        {/* Hero */}
        <header className="about-header">
          <h1>We got tired of applying. So we automated it.</h1>
          <p className="about-header__subtitle">
            ApplyAI was built by students who spent 40+ hours copying and pasting the same resume into identical forms. We knew there had to be a better way, so we built one.
          </p>
        </header>

        {/* What We Do */}
        <section className="about-section">
          <h2>One upload. Hundreds of applications.</h2>
          <p>
            You upload your resume and tell us what you're looking for: role, location, salary, company size. ApplyAI does the rest.
          </p>
          <p>
            We submit real applications through official job portals. We write personalized cold emails to recruiters at companies you care about. We track every status change and notify you the moment something moves.
          </p>
          <p>
            You wake up to interview invites instead of more forms to fill out.
          </p>
        </section>

        {/* Our Story */}
        <section className="about-section">
          <h2>Born from a spreadsheet with 200 rows.</h2>
          <p>
            In the fall of 2024, our founding team was deep in internship recruiting season. Between us, we had a shared Google Sheet with over 200 rows: company names, application links, deadlines, statuses, recruiter emails. Half the cells were yellow. A third were outdated. Nobody knew who had actually hit submit.
          </p>
          <p>
            One night after spending three hours applying to four companies, someone said "why are we doing this manually?" The next morning we started building.
          </p>
          <p>
            The first version of ApplyAI applied to 12 internships overnight. Within a week, all three of us had interview callbacks from companies we hadn't gotten to yet. Within a month, friends were asking for access. Within a semester, thousands of students were using it.
          </p>
          <p>
            We're still students. We still use ApplyAI every recruiting season. And we still update it every week based on what we and our users need.
          </p>
        </section>

        {/* By the Numbers */}
        <section className="about-section">
          <h2>By the Numbers</h2>
          <div className="about-stats">
            <div className="about-stat">
              <span className="about-stat__number">10,000+</span>
              <span className="about-stat__label">applications submitted, and counting</span>
            </div>
            <div className="about-stat">
              <span className="about-stat__number">5,000+</span>
              <span className="about-stat__label">students trust ApplyAI with their job search</span>
            </div>
            <div className="about-stat">
              <span className="about-stat__number">500+</span>
              <span className="about-stat__label">offers landed through automated outreach</span>
            </div>
            <div className="about-stat">
              <span className="about-stat__number">40 hrs</span>
              <span className="about-stat__label">saved per user, per month</span>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="about-section">
          <h2>What We Believe</h2>
          <div className="about-values">
            <div className="about-value">
              <h3>Build for yourself first.</h3>
              <p>
                We use ApplyAI. Every feature ships because we needed it, tested it on our own job searches, and confirmed it actually helps before releasing it to anyone else.
              </p>
            </div>
            <div className="about-value">
              <h3>No black boxes.</h3>
              <p>
                You see every application we submit, every email we send, every data point we access. If you wouldn't be comfortable with a friend watching over your shoulder, we don't do it.
              </p>
            </div>
            <div className="about-value">
              <h3>Ship weekly. Listen daily.</h3>
              <p>
                We push updates every week. Our roadmap isn't built in a boardroom, it's built from support tickets, Discord messages, and the things we wish worked better when we use the product ourselves.
              </p>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="about-contact">
          <p>
            Want to learn more? Reach out at{' '}
            <a href="mailto:hello@applyai.co">hello@applyai.co</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default AboutUs;
